// API
import { Grow } from "@mui/material";
import * as api from "../../api";

// Aciton types
import {
    AUTH_ERROR,
    AUTH_REQUEST,
    AUTH_RESPONSE,
    AUTH_ERROR_EMPTY,
    LOGOUT_ERROR,
    LOGOUT_REQUEST,
    LOGOUT_RESPONSE,
    INCREMENT_TOKEN,
    DECREMENT_TOKEN,
    INCREMENT_TROPHY,
    DECREMENT_MONEY,
    DECREMENT_MONEY_ERROR
} from "../../constants/actionTypes";

export const auth = () => async dispatch => {
    try {
        dispatch({ type: AUTH_REQUEST });
        const { data } = await api.auth();
        dispatch({ type: AUTH_RESPONSE, payload: data.data.user });
    } catch (error) {
        console.log(error.response);
        if(err?.response.status === 401){
            dispatch({ type: LOGOUT_REQUEST });
            await api.logout();
            dispatch({ type: LOGOUT_RESPONSE });
            enqueueSnackbar("لطفا مجدد وارد شوید", {
                variant: "error",
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                TransitionComponent: Grow
            });
        }
    }
};

export const logout = navigate => async dispatch => {
    try {
        dispatch({ type: LOGOUT_REQUEST });
        await api.logout();
        dispatch({ type: LOGOUT_RESPONSE });
        navigate("/");
    } catch (error) {
        console.log(error.response);
        dispatch({ type: LOGOUT_ERROR });
    }
};

export const login = (formData, enqueueSnackbar) => async dispatch => {
    try {
        dispatch({ type: AUTH_REQUEST });
        const { data } = await api.login(formData);
        dispatch({ type: AUTH_RESPONSE, payload: data.data.user });
    } catch (error) {
        if(err?.response.status === 401){
            dispatch({ type: LOGOUT_REQUEST });
            await api.logout();
            dispatch({ type: LOGOUT_RESPONSE });
            enqueueSnackbar("لطفا مجدد وارد شوید", {
                variant: "error",
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                TransitionComponent: Grow
            });
        }else{
            dispatch({ type: AUTH_ERROR, error: error.response });
            enqueueSnackbar("کد تأیید معتبر نیست", {
                variant: "error",
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                TransitionComponent: Grow
            });
        }
    }
};

export const register = (formData, enqueueSnackbar) => async dispatch => {
    try {
        dispatch({ type: AUTH_REQUEST });
        const { data } = await api.register(formData);
        dispatch({ type: AUTH_RESPONSE, payload: data.data.user });
    } catch (err) {
        if (err?.response.status === 406) {
            enqueueSnackbar("کاربری با این ایمیل ثبت نام کرده است.", {
                variant: "error",
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                TransitionComponent: Grow
            });
        }
        if(err?.response.status === 403 || err?.response.status === 404){
            dispatch({ type: AUTH_ERROR, error: err.response });
            enqueueSnackbar("کد تأیید معتبر نیست", {
                variant: "error",
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                TransitionComponent: Grow
            });
        }
        if(err?.response.status === 400){
            dispatch({ type: AUTH_ERROR, error: err.response });
            enqueueSnackbar("لطفا شماره تلفن را به درستی وارد کنید", {
                variant: "error",
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                TransitionComponent: Grow
            });
        }
        if(err?.response.status === 401){
            dispatch({ type: LOGOUT_REQUEST });
            await api.logout();
            dispatch({ type: LOGOUT_RESPONSE });
            enqueueSnackbar("لطفا مجدد وارد شوید", {
                variant: "error",
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                TransitionComponent: Grow
            });
        }
    }
};

export const googleLogin = (formData, enqueueSnackbar) => async dispatch => {
    try {
        dispatch({ type: AUTH_REQUEST });
        const { data } = await api.googleLogin(formData);
        console.log('datas',data.data.user);
        dispatch({ type: AUTH_RESPONSE, payload: data.data.user });
    } catch (err) {
        dispatch({ type: AUTH_ERROR, error: err.response.data.message });
        enqueueSnackbar(`خطا در ورود با گوگل.(${err.response.data.message})`, {
           variant: "error",
           anchorOrigin: { vertical: "bottom", horizontal: "left" },
           TransitionComponent: Grow
       });
    }
};

export const updateUser = (formData, enqueueSnackbar) => async dispatch => {
    try {
        dispatch({ type: AUTH_REQUEST });
        const { data } = await api.updateUser(formData);
        dispatch({ type: AUTH_RESPONSE, payload: data.data.user });
        enqueueSnackbar("تغییرات با موفقیت اعمال شد", {
            variant: "success",
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            TransitionComponent: Grow
        });
    } catch (error) {
        console.log(error.response);
        dispatch({ type: AUTH_ERROR, error: error.response });
        enqueueSnackbar("خطا!", {
            variant: "error",
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            TransitionComponent: Grow
        });
    }
};

export const incrementToken = token => ({ type: INCREMENT_TOKEN, payload: token });

export const decrementToken = token => ({ type: DECREMENT_TOKEN, payload: token });

export const decrementMoney = amount => async dispatch=>{
    try {
        dispatch({ type: DECREMENT_MONEY, payload: token })
        const { data } = await api.updateUser(formData);
        enqueueSnackbar("تغییرات با موفقیت اعمال شد", {
            variant: "success",
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            TransitionComponent: Grow
        });
    } catch (error) {
        dispatch({ type: DECREMENT_MONEY_ERROR, error: error.response });
        enqueueSnackbar("خطا!", {
            variant: "error",
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            TransitionComponent: Grow
        });
    }
};

export const incrementTrophy = trophy => ({ type: INCREMENT_TROPHY, payload: trophy });

export const setErrorEmpty = () => ({ type: AUTH_ERROR_EMPTY });
